import execute_on from "../../../libs/execute-on";

execute_on('panel.transaction.choose-payment-method', function ($page) {
    $('input.paymentMethod').on('change', checkSelectedPaymentMethod);

    checkSelectedPaymentMethod();

    function checkSelectedPaymentMethod() {
        $('.splitPaymentPointsCount').toggleClass('hide', !$('#split').is(':checked'));
    }
});
